import { Autocomplete, TextField, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { useSelector } from "react-redux";
import moment from "moment";

const GoogleTranslate = () => {
  // Initialize Google Translate widget{ value: "en", label: "English" }
  const [languageList, setLanguageList] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({ value: "en", lang: "English" });
  const { appConstants } = useSelector((state) => state.service);

  const getCookieDomain = () => {
    const { hostname } = window.location;
    const parts = hostname.split(".");

    // For localhost or IP-like hosts, avoid setting a domain so the cookie is host-only
    if (hostname === "localhost" || parts.length < 2) {
      return "";
    }

    const rootDomain = parts.slice(-2).join(".");
    return `.${rootDomain}`;
  };

  const googleTranslateElementInit = () => {
    const google = window.google;
    if (!google || !google.translate || !google.translate.TranslateElement) {
      // Script not loaded or API not available; safely no-op
      // eslint-disable-next-line no-console
      console.error("Google Translate script is not available on window.google.");
      return;
    }

    new google.translate.TranslateElement(
      {
        pageLanguage: "en",
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
        autoDisplay: false,
      },
      "google_translate_element"
    );
  };

  // const setLanguageOptions = async () => {
  //   const languageData = await getLanguageOptions();
  //   const languagesList = languageData.map((language, index) => ({
  //     value: language.language + index,
  //     id: language.language,
  //     label: language.name,
  //   }));
  //   console.log("000", languagesList);
  // };

  // useEffect(() => {
  //   const asyncFn = async () => await setLanguageOptions();
  //   asyncFn();
  // }, []);
  useEffect(() => {
    const cookies = new Cookies();
    const currentCookie = cookies.get("googtrans");
    if (currentCookie) {
      setSelectedLanguage(
        appConstants?.appLanguages?.find((lang) => lang.value === currentCookie?.split("/")[2]) || { value: "en", lang: "English" }
      );
    }
    const langList = appConstants?.appLanguages || [];
    setLanguageList([...langList].sort((a, b) => a.lang.localeCompare(b.lang)) || []);
  }, [appConstants]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;

    // Expose the callback expected by Google Translate script.
    window.googleTranslateElementInit = () => {
      try {
        googleTranslateElementInit();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to initialize Google Translate widget.", error);
      }
    };

    script.onerror = (error) => {
      // eslint-disable-next-line no-console
      console.error("Failed to load Google Translate script.", error);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      // Clean up the global callback
      try {
        delete window.googleTranslateElementInit;
      } catch {
        window.googleTranslateElementInit = undefined;
      }
    };
  }, []);
  const langChange = (e, newValue) => {
    e.preventDefault();
    if (!newValue) return;

    const cookieDomain = getCookieDomain();
    const targetLang = newValue?.value || "en";
    const expiryDate = moment(new Date()).add(1, "year").format("DD MMM YYYY");

    // Clear existing cookies on root domain (if any) and current host
    if (cookieDomain) {
      document.cookie = `googtrans=; max-age=-1; domain=${cookieDomain}; path=/;`;
    }
    document.cookie = "googtrans=; max-age=-1; path=/;";

    // Set new cookies for host and (if applicable) root domain
    document.cookie = `googtrans=/en/${targetLang}; expires=Thu, ${expiryDate} 00:00:00 UTC; path=/;`;
    if (cookieDomain) {
      document.cookie = `googtrans=/en/${targetLang}; expires=Thu, ${expiryDate} 00:00:00 UTC; domain=${cookieDomain}; path=/;`;
    }

    setSelectedLanguage(newValue);

    // Full reload is currently required for all field-level translations
    // (they read googtrans on mount). Keeping this to avoid breaking behavior.
    window.location.reload();
  };
  return (
    <div className="notranslate">
      <Box sx={{ mr: 2 }}>
        {/* <div id="google_translate_element" /> */}

        <Autocomplete
          disablePortal
          size="small"
          options={languageList}
          fullWidth
          className="notranslate"
          value={selectedLanguage}
          isOptionEqualToValue={(option, value) => option.lang == value.lang}
          getOptionLabel={(option) => option.lang}
          sx={{ minWidth: 200 }}
          onChange={(e, newValue) => langChange(e, newValue)}
          renderInput={(params) => <TextField {...params} />}
        />
      </Box>
    </div>
  );
};

export default GoogleTranslate;
